import React from 'react';
import './features.css';
import FeatureBlock from '../FeatureBlock';
const imageSrc = require('../../../../../assets/images/condo-5.png');

const Features = () => {
  return (
    <div className="features">
      <div className="features-header">
        <h2 className="features-header-text">Features</h2>
        <hr className="border" />
      </div>
      <div className="features-body">
        <div className="phone-image">
          <img
            src={imageSrc}
            width={351}
            height={675}
            alt="zonetail app preview"
          />
        </div>
        <div className="features-list">
          <FeatureBlock
            title="General Information"
            body="Building management and board contact information. Building event and maintenance calendar. Safety and security information."
          />
          <FeatureBlock
            title="Maintenance requests"
            body="Your 24/7 office to allow residents to submit maintenance and service requests and reports."
          />
          <FeatureBlock
            title="Resident services and amenities"
            body="The booking of building amenities, community news, and the distribution of other important building information."
          />
          <FeatureBlock
            title="In-app messaging and push notifications"
            body="Upcoming maintenance, events, requests, and notices delivered directly to residents, alerting and reminding them on-time."
          />
          <FeatureBlock
            title="Access the neighborhood through"
            titleLink="Explore"
            body="The neighborhood section includes businesses, stores, and services offering contextually relevant information and custom offers."
          />
        </div>
      </div>
    </div>
  );
};

export default Features;
